import EditSavedFiltersDrawer from './edit-saved-filters-drawer';

export default EditSavedFiltersDrawer;
